import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ThirdPartySource } from '../_types/third-party-source';
import { ThirdPartiesSourcesService } from '../_services/third-party-source.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../login/login.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-third-parties-sources-detail',
    templateUrl: './third-parties-sources-detail.component.html',
    styleUrls: ['./third-parties-sources-detail.component.scss'],
    standalone: false
})
export class ThirdPartiesSourcesDetailComponent {
  public thirdPartySourceFormGroup!: RxFormGroup;
  public thirdPartySource: ThirdPartySource = new ThirdPartySource();
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private thirdPartiesSourcesService: ThirdPartiesSourcesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService
  ) {

    this.thirdPartySourceFormGroup = this.formBuilder.formGroup<ThirdPartySource>(this.thirdPartySource) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalle de origen de cliente");
    this.topbarService.addBreadcrumb("Orígenes de cliente", "/thirdPartiesSources");
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadThirdPartyService(id);
    }
    this.allowWrite = true; //this.loginService.hasPermission("CASES_TYPES.WRITE");
    this.allowDelete = true; //this.loginService.hasPermission("CASES_TYPES.DELETE");
  }

  async loadThirdPartyService(id: string) {
    this.thirdPartySource = await firstValueFrom(this.thirdPartiesSourcesService.get(id));
    this.thirdPartySourceFormGroup.patchValue(this.thirdPartySource);
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.thirdPartySourceFormGroup);
    if (valid) {
      this.thirdPartySource = Object.assign(this.thirdPartySource, this.thirdPartySourceFormGroup.value);
      let thirdPartySource = await firstValueFrom(this.thirdPartiesSourcesService.save(this.thirdPartySource));
      this.messageService.add({ closable: true, severity: 'success', summary: "Origen guardado correctamente." });
      this.router.navigate(['thirdPartiesSources']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el origen?",
      header: "Eliminar origen",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.thirdPartiesSourcesService.delete(this.thirdPartySource.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Origen eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['thirdPartiesSources']);
  }

}
